var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('v-row',[_c('bubble-chart',{staticStyle:{"position":"relative","width":"92%","max-height":"250px","height":"250px"},attrs:{"chart-data":_vm.bubbleData,"options":_vm.bubbleOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }